import { useMemo } from 'react';

interface UseResponsiveTicksOptions {
  width: number;
  defaultTicks?: number;
  breakpoints?: {
    small?: { width: number; ticks: number };
    medium?: { width: number; ticks: number };
    large?: { width: number; ticks: number };
  };
}

export function useResponsiveTicks({
  width,
  defaultTicks = 16,
  breakpoints = {
    small: { width: 600, ticks: 4 },
    medium: { width: 900, ticks: 8 },
    large: { width: 1200, ticks: 12 },
  },
}: UseResponsiveTicksOptions) {
  return useMemo(() => {
    if (width < breakpoints.small!.width) return breakpoints.small!.ticks;
    if (width < breakpoints.medium!.width) return breakpoints.medium!.ticks;
    if (width < breakpoints.large!.width) return breakpoints.large!.ticks;
    return defaultTicks;
  }, [width, defaultTicks, breakpoints]);
}
